import { BetterWebsocket } from "./BetterWebsocket.js";
import { getPanelToken } from "../auth/AuthActions.js";

import { NotificationManager } from "react-notifications";

import store from "../index.js";
import { selectSiteName, sitesFetch } from "../sitesSlice.js";
import { panelsFetch } from "../panelsSlice.js";

import {  updateRuntimeReport } from "../realtimeSlice.js";
import { siteConnected, siteDisconnected } from "../connectionSlice.js";
import { loadEvents } from "../eventsSlice.js";
import { appendNotifications } from "../notificationsSlice.js";
let mainWebsocketFeed = new BetterWebsocket(`${(location.protocol == "https:" ? "wss" : "ws")}://${location.host}/api/livefeed`);
let _prevClaims = null;

let attempts = 0;
let hasWarned = false;
 
// mainWebsocketFeed.once("open", () => {
//     store.subscribe(() => {
//         sendToken();
//     })
// });

function sendToken(){
    if (_prevClaims != store.getState().auth.claims) {
        _prevClaims = store.getState().auth.claims;
        mainWebsocketFeed.send(JSON.stringify({ type: "TOKEN_SET", payload: store.getState().auth.claims }));
    }
}

mainWebsocketFeed.on("close", ()=> { _prevClaims = null; })
mainWebsocketFeed.on("open", ()=> { 
    if(attempts > 5){
        NotificationManager.info("", "Live Updates Connected.", 15000);
    }
    attempts = 0;
    hasWarned = false;
    mainWebsocketFeed._backoff = 5;

    console.log("Opened");
});
mainWebsocketFeed.on("reconnect", ()=> { 
    console.log("Reconnecting");
    attempts ++;
    if(attempts > 5 && !hasWarned){
        hasWarned = true;
        NotificationManager.warning("Cannot connect to live updates, notifications may be delayed.", "Live Updates Issue", 15000);
        mainWebsocketFeed._backoff = 15;
        console.warn("Experiencing Websocket connectivity issues, lowering retry to once per 15 seconds");
    }
    _prevClaims = null; 
})
mainWebsocketFeed.on("message", ev => {
    let { type, data } = JSON.parse(ev.data);

    switch (type) {
        case "INIT":
            //SEND TOKEN
            store.dispatch(getPanelToken()).then(() => {
                sendToken()
            });
            break;
        case "AUTH_CHK":
            console.log("BetterWebsocket :: Auth Check fired");
            store.dispatch(getPanelToken(true))
                .then(()=>{
                    store.dispatch(sitesFetch());
                    sendToken();
                });
            break;
        case "NotificationEvent":
            console.log("BetterWebsocket :: Notification Event");
            store.dispatch(appendNotifications([data]));
            break;
        case "LogEvent":
            console.log("BetterWebsocket :: Log Event");
            switch (data.category) {
                case "fire": NotificationManager.error(data.title, "Fire", 30000); break;
                case "fault": NotificationManager.warning(data.title, "Fault", 30000); break;
                default: NotificationManager.info(data.title, data.category.charAt(0).toUpperCase() + data.category.slice(1)); break;
            }
            store.dispatch(loadEvents(data.hwaddr));
            store.dispatch(sitesFetch());

            break;
        case "Connection":
            console.log("BetterWebsocket :: Connection Event");
            store.dispatch(panelsFetch(data.hwaddr));

            if (data.connected) {
                store.dispatch(siteConnected(data.hwaddr));
                NotificationManager.success(`Site ${selectSiteName(store.getState(), data.hwaddr)} connected`)
            } else {
                store.dispatch(siteDisconnected(data.hwaddr));
                NotificationManager.warning(`Site ${selectSiteName(store.getState(), data.hwaddr)} disconnected`)
            }
            break;
        case "Runtime":
            console.log("BetterWebsocket :: Runtime Event");
            store.dispatch(updateRuntimeReport(data.hwaddr, data.networkId, data.report));
            break;
        case "Resync":

            // NotificationManager.info(`Changes detected in ${data.join("\n")}`, "Panel changes detected");
            store.dispatch(sitesFetch());
            store.dispatch(panelsFetch( data.hwaddr))
            break;
        case "ConfigSync":
            console.log("BetterWebsocket :: Config Sync Event");
            // if (!isPanelConnected()) {
            //     NotificationManager.warning("changes made at panel. please enable cloud to synchronise", "Panel changes detected", 15000);
            // } else {
            //     NotificationManager.warning("Syncronizing with panel...", "Panel changes detected");
            // }
            break;
    }


});